import { render, staticRenderFns } from "./DictionaryNameField.vue?vue&type=template&id=25131f56&scoped=true&"
import script from "./DictionaryNameField.vue?vue&type=script&lang=js&"
export * from "./DictionaryNameField.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryNameField.vue?vue&type=style&index=0&id=25131f56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25131f56",
  null
  
)

export default component.exports